import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { TUI_DARK_MODE } from '@taiga-ui/core/tokens';

import { BRANDING_CONFIGS } from '@branding/branding.config';
import { selectCurrentUser } from '@store/selectors/current_user.selectors';

import { TabInfo, tabs } from './sidebar-tabs-config';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  providers: [],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SidebarComponent implements OnInit {
  private readonly night = inject(TUI_DARK_MODE);
  private readonly store = inject(Store);

  @Output() changeSidebarState = new EventEmitter();
  @Output() navigationSelected = new EventEmitter<void>();

  @Input() mobileOpen = false;

  isExpanded = !!localStorage.getItem('isExpanded');
  isOpenedSettings = false;

  protected readonly TABS: TabInfo[] = tabs;
  private readonly defaultBrand = BRANDING_CONFIGS['default'];

  get sidebarLogo() {
    return this.defaultBrand.logo.sidebar;
  }

  get sidebarLogoSrc(): string {
    const logo = this.sidebarLogo.useExpandedCollapsed
      ? this.isExpanded || this.mobileOpen
        ? this.sidebarLogo.expanded
        : this.sidebarLogo.collapsed
      : this.sidebarLogo.default;

    return (this.night() ? logo?.onDark : logo?.onLight) || '';
  }

  get sidebarLogoClassName(): string {
    return this.sidebarLogo.type === 'png' ? this.defaultBrand.className || '' : 'icon-logo';
  }

  constructor() {
    this.store
      .select(selectCurrentUser)
      .pipe(takeUntilDestroyed())
      .subscribe((user) => {
        if (user) {
          this.TABS.map((tab) => {
            if (tab.key === 'trash') {
              tab.access = user.accountType === 'partner' && (user.isAdmin || user.hasAdminAccess);
            }
          });
        }
      });
  }

  ngOnInit(): void {
    this.changeSidebarState.emit(this.isExpanded);
  }

  setIsExpanded(isExpanded: boolean) {
    this.isExpanded = isExpanded;
    this.changeSidebarState.emit(this.isExpanded);
    this.isExpanded
      ? localStorage.setItem('isExpanded', 'true')
      : localStorage.removeItem('isExpanded');
  }

  onDblClickLogo() {
    window.open(window.location.href, '_blank');
  }
}
